import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    agente_id: { required },
    ramal: { required },
  },
}

export const validateComputed = {
  agenteIdErrors() {
    const errors = []
    if (!this.$v.form.agente_id.$dirty) return errors
    !this.$v.form.agente_id.required && errors.push('Agente é obrigatório.')
    return errors
  },
  ramalErrors() {
    const errors = []
    if (!this.$v.form.ramal.$dirty) return errors
    !this.$v.form.ramal.required && errors.push('Ramal é obrigatório.')
    return errors
  },
}
